import { ToggleSRPFloatingAIChatMobile } from '@/src/components/common/srp/aiFilter/ToggleSRPFloatingAIChatMobile'
import { selectSRPFloatingAIChatEnabled } from '@/src/redux/slices/aiFeatureSlice'
import { useAppSelector } from '@/src/redux/store'
import { FilterList as SortIcon, Tune } from '@mui/icons-material'
import { Badge, Box, ButtonBase, Typography } from '@mui/material'
import React from 'react'

interface FloatingFilterBarProps {
    filtersCount: number
    nonStopEnabled: boolean
    nonStopChecked: boolean
    onFilterClick?: () => void
    onSortClick?: () => void
    onNonStopClick?: () => void
    filterLabel: string
    sortLabel: string
    nonStopLabel: string
}


const FloatingFilterBar: React.FC<FloatingFilterBarProps> = ({
    filtersCount,
    nonStopEnabled,
    nonStopChecked,
    onFilterClick,
    onSortClick,
    onNonStopClick,
    filterLabel,
    sortLabel,
    nonStopLabel,
}) => {
    const hasFiltersApplied = filtersCount > 0
    const srpFloatingAIChatEnabled = useAppSelector(selectSRPFloatingAIChatEnabled)
    return (
        <Box
            sx={srpFloatingAIChatEnabled ? {} : {
                position: 'fixed',
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: theme => theme.zIndex.appBar + 1,
                px: 2,
                pb: theme => `calc(${theme.spacing(1.5)} + env(safe-area-inset-bottom))`,
                pt: 1.5,
                display: 'flex',
                justifyContent: 'center',
                pointerEvents: 'none',
                // border: "1px solid red"
            }}
        >
            <Box
                sx={srpFloatingAIChatEnabled ? { display: 'flex', alignItems: 'stretch', px: 1, py: 1, gap: 1, bgcolor: 'background.paper', } : {
                    pointerEvents: 'auto',
                    minWidth: 232,
                    maxWidth: '100%',
                    minHeight: 61,
                    maxHeight: "100%",
                    borderRadius: 1.5,
                    borderWidth: 1,
                    borderStyle: 'solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    boxShadow: 3,
                    display: 'flex',
                    alignItems: 'stretch',
                    justifyContent: 'space-between',
                    px: 1,
                    py: 1,
                    gap: 0.5,
                    // border: "1px solid red"
                }}
            >
                <ButtonBase
                    onClick={onFilterClick}
                    sx={srpFloatingAIChatEnabled ? {
                        display: 'flex',
                        gap: 1,
                        borderRadius: 1.5,
                        border: 1,
                        px: 1,
                        py: 0,
                        height: "30px"
                    } : {
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 1.5,
                        height: '100%'
                    }}
                >
                    <Badge
                        color="primary"
                        badgeContent={filtersCount}
                        invisible={!hasFiltersApplied}
                        overlap="circular"
                    >
                        <Tune fontSize="small" />
                    </Badge>
                    <Typography variant="caption" sx={{ fontWeight: 500, mt: srpFloatingAIChatEnabled ? undefined : 0.5 }}>
                        {filterLabel}
                    </Typography>
                </ButtonBase>

                {nonStopEnabled && (
                    <ButtonBase
                        onClick={onNonStopClick}
                        sx={srpFloatingAIChatEnabled ? {
                            display: 'flex',
                            gap: 1,
                            borderRadius: 1.5,
                            border: 1,
                            px: 1,
                            py: 0,
                            height: "30px"
                        } : {
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: 1.5,
                            height: '100%'
                        }}
                    >
                        <Box
                            sx={theme => ({
                                width: 28,
                                height: 16,
                                borderRadius: 999,
                                display: 'flex',
                                alignItems: 'center',
                                px: 0.3,
                                justifyContent: nonStopChecked ? 'flex-end' : 'flex-start',
                                mb: 0.25,
                                bgcolor: nonStopChecked ? theme.palette.primary.main : theme.palette.background.paper,
                                border: `1px solid ${theme.palette.textColors?.secondary || theme.palette.text.secondary
                                    }`
                            })}
                        >
                            <Box
                                sx={theme => ({
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    bgcolor:
                                        theme.palette.textColors?.secondary || theme.palette.text.secondary,
                                    backgroundColor:
                                        nonStopChecked ? theme.palette.common.white : undefined
                                })}
                            />
                        </Box>
                        <Typography variant="caption" sx={{ fontWeight: 500, mt: srpFloatingAIChatEnabled ? undefined : 0.5 }}>
                            {nonStopLabel}
                        </Typography>
                    </ButtonBase>
                )}

                <ButtonBase
                    onClick={onSortClick}
                    sx={srpFloatingAIChatEnabled ? {
                        display: 'flex',
                        gap: 1,
                        borderRadius: 1.5,
                        border: 1,
                        px: 1,
                        py: 0,
                        height: "30px"
                    } : {
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 1.5,
                        height: '100%'
                    }}
                >
                    <SortIcon fontSize="small" color='primary' />
                    <Typography variant="caption" sx={{ fontWeight: 500, mt: srpFloatingAIChatEnabled ? undefined : 0.5 }}>
                        {sortLabel}
                    </Typography>
                </ButtonBase>
                {!srpFloatingAIChatEnabled && <ToggleSRPFloatingAIChatMobile />}

            </Box>
        </Box>
    )
}

export default FloatingFilterBar
